
import { Component, Prop, Vue } from 'vue-property-decorator';

interface BadgeConfig {
  label: string;
  color: string;
  textColor: string;
  icon: string;
}

/**
 * Story 20: payment status badge. Status itself is never computed here — the
 * caller passes `status` (from the server) and `isOverdue` (a date-based overlay).
 */
@Component
export default class POPaymentStatusBadge extends Vue {
  @Prop({ type: String, default: 'unpaid' }) readonly status!: 'unpaid' | 'partial' | 'paid' | null;
  @Prop({ type: Boolean, default: false }) readonly isOverdue!: boolean;
  @Prop({ type: Boolean, default: false }) readonly small!: boolean;

  get config(): BadgeConfig {
    if (this.isOverdue && this.status !== 'paid') {
      return { label: 'Overdue', color: 'red lighten-5', textColor: 'red darken-2', icon: 'mdi-clock-alert-outline' };
    }
    switch (this.status) {
      case 'paid':
        return { label: 'Paid', color: 'green lighten-5', textColor: 'green darken-2', icon: 'mdi-check-circle-outline' };
      case 'partial':
        return { label: 'Partial', color: 'blue lighten-5', textColor: 'blue darken-2', icon: 'mdi-circle-half-full' };
      default:
        return { label: 'Unpaid', color: 'grey lighten-3', textColor: 'grey darken-3', icon: 'mdi-circle-outline' };
    }
  }
}
